import React from 'react';
import { Colors } from '@common/tokens';

// NOTE: mirrors the boot skeleton's content block in
// app/views/layouts/_static_skeleton.html.erb so the handoff reads as one loading state.
export const ContentSkeleton = () => (
  <div className="wk-content-skeleton">
    <div className="wk-content-skeleton__title" />
    <div className="wk-content-skeleton__line wk-content-skeleton__line--full" />
    <div className="wk-content-skeleton__line wk-content-skeleton__line--full" />
    <div className="wk-content-skeleton__line wk-content-skeleton__line--wide" />
    <div className="wk-content-skeleton__line wk-content-skeleton__line--narrow" />
    <style jsx>{`
      .wk-content-skeleton {
        max-width: 960px;
        padding: 32px 24px;
      }
      .wk-content-skeleton__title {
        width: 30%;
        height: 24px;
        margin-bottom: 24px;
        border-radius: 4px;
        background: ${Colors.steelLighter};
        animation: wk-content-skeleton-pulse 1.5s ease-in-out infinite;
      }
      .wk-content-skeleton__line {
        height: 16px;
        margin-bottom: 12px;
        border-radius: 4px;
        background: ${Colors.steelLightest};
        animation: wk-content-skeleton-pulse 1.5s ease-in-out 0.15s infinite;
      }
      .wk-content-skeleton__line--full {
        width: 100%;
      }
      .wk-content-skeleton__line--wide {
        width: 80%;
      }
      .wk-content-skeleton__line--narrow {
        width: 60%;
      }
      @keyframes wk-content-skeleton-pulse {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.4;
        }
      }
    `}</style>
  </div>
);
